import React from "react";

const AthleticInfo = (props) => {
  return (
    <>
      <div className="card">
        <h3>Athletic Information</h3>
        <div className="card-body">
          {props.data?.uncommonNewData?.sport && (
            <div class="datas">
              <p>Sport:</p>
              <del>{props.data?.uncommonOldData?.sport}</del>
              <span>{props.data?.uncommonNewData?.sport}</span>
            </div>
          )}
          {props.data?.uncommonNewData?.primaryPosition && (
            <div class="datas">
              <p>Primary Position:</p>
              <del>{props.data?.uncommonOldData?.primaryPosition}</del>
              <span>{props.data?.uncommonNewData?.primaryPosition}</span>
            </div>
          )}
          {props.data?.uncommonNewData?.secondaryPosition && (
            <div class="datas">
              <p>Secondary Position:</p>
              <del>{props.data?.uncommonOldData?.secondaryPosition}</del>
              <span>{props.data?.uncommonNewData?.secondaryPosition}</span>
            </div>
          )}
          {props.data?.uncommonNewData?.bats && (
            <div class="datas">
              <p>Bats:</p>
              <del>{props.data?.uncommonOldData?.bats}</del>
              <span>{props.data?.uncommonNewData?.bats}</span>
            </div>
          )}
          {props.data?.uncommonNewData?.throws && (
            <div class="datas">
              <p>Throws:</p>
              <del>{props.data?.uncommonOldData?.throws}</del>
              <span>{props.data?.uncommonNewData?.throws}</span>
            </div>
          )}
          {props.data?.uncommonNewData?.specialtyMetrics && (
            <div class="datas">
              <p>Specialty Metrics:</p>
              <del>{props.data?.uncommonOldData?.specialtyMetrics}</del>
              <span>{props.data?.uncommonNewData?.specialtyMetrics}</span>
            </div>
          )}
          {props.data?.uncommonNewData?.clubName && (
            <div class="datas">
              <p>Club Name:</p>
              <del>{props.data?.uncommonOldData?.clubName}</del>
              <span>{props.data?.uncommonNewData?.clubName}</span>
            </div>
          )}
          {props.data?.uncommonNewData?.clubTeamName && (
            <div class="datas">
              <p>Club Team Name:</p>
              <del>{props.data?.uncommonOldData?.clubTeamName}</del>
              <span>{props.data?.uncommonNewData?.clubTeamName}</span>
            </div>
          )}
          {props.data?.uncommonNewData?.jersey && (
            <div class="datas">
              <p>Club Team Jersey#:</p>
              <del>{props.data?.uncommonOldData?.jersey}</del>
              <span>{props.data?.uncommonNewData?.jersey}</span>
            </div>
          )}
          {props.data?.uncommonNewData?.height && (
            <div class="datas">
              <p>Height:</p>
              <del>{props.data?.uncommonOldData?.height}</del>
              <span>{props.data?.uncommonNewData?.height}</span>
            </div>
          )}
          {props.data?.uncommonNewData?.weight && (
            <div class="datas">
              <p>Weight:</p>
              <del>{props.data?.uncommonOldData?.weight}</del>
              <span>{props.data?.uncommonNewData?.weight}</span>
            </div>
          )}
          {props.data?.uncommonNewData?.ncaaId && (
            <div class="datas">
              <p>NCAA / NAIA#:</p>
              <del>{props.data?.uncommonOldData?.ncaaId}</del>
              <span>{props.data?.uncommonNewData?.ncaaId}</span>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default AthleticInfo;
